/* tjs <- settings.ts */

export const settings = {
    debug: false,
    perf: false,
};